<template>
  <b-modal
    :id="id"
    :hide-footer="modalLoading"
    body-class="py-0 text-secondary saving-modal-body"
    centered
    footerClass="p-2 border-top-0 d-flex justify-content-center"
    headerClass="p-2 mt-2 border-bottom-0 d-flex justify-content-center"
    no-close-on-backdrop
    no-close-on-esc
    @ok="$emit('handleOk')"
  >
    <div v-if="modalLoading" id="loadingSpinner" class="text-center text-primary my-2">
      <b-spinner class="align-middle primary p-3"></b-spinner>
    </div>
    <div v-if="!modalLoading && (this.saveResponseStatus == 200 || this.saveResponseStatus == 201)">
      <b-icon class="h2 mb-0" icon="check-circle-fill" variant="success"></b-icon>
      <p class="saving-modal-title my-3">{{ modalTitle }}</p>
      <p>{{ modalSuccessMessage }}</p>
    </div>
    <div
      v-if="!modalLoading && !(this.saveResponseStatus == 200 || this.saveResponseStatus == 201)"
    >
      <b-icon class="h2 mb-0 align-middle" icon="x-circle-fill" variant="danger"></b-icon>
      <p class="saving-modal-title my-3">{{ modalTitle }}</p>
      <p v-html="errorMessage"></p>
    </div>
    <template #modal-header>
      <div></div>
    </template>
    <template #modal-footer="{ ok }">
      <b-button
        :disabled="busy"
        pill
        style="padding-inline: 5rem"
        variant="outline-primary"
        @click="ok()"
      >
        OK
      </b-button>
    </template>
  </b-modal>
</template>
<script>
  export default {
    props: [
      'modalLoading',
      'saveResponseStatus',
      'busy',
      'modalTitle',
      'errorMessage',
      'modalSuccessMessage',
      'id',
    ],
  };
</script>
<style>
  .saving-modal-body {
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
  }
  .saving-modal-title {
    font-size: 20px;
    line-height: 28px;
    color: #383838;
  }
</style>
